// extracted by mini-css-extract-plugin
export default {"block":"Link_block__lHbyH","title":"Link_title__Zv-yr","text":"Link_text__+K06Z","textInvalid":"Link_textInvalid__ReDtN"};